export default "__VITE_ASSET__BXpZQJ8C__"